import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import CardTitle from "@saleor/components/CardTitle";
import FormSpacer from "@saleor/components/FormSpacer";
import { ProductErrorFragment } from "@saleor/fragments/types/ProductErrorFragment";
import { getFormErrors, getProductErrorMessage } from "@saleor/utils/errors";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
interface ProductDescriptionProps {
  data: {
    // fromColor: string;
    // toColor: string;
    shortDescription: string;
    fullDescription: string;
    skuName: string;
    describe: string;
    USP: string;
    framesImg: string;
    framesVideo: string;
  };
  disabled: boolean;
  errors: ProductErrorFragment[];
  onChange: (event: React.ChangeEvent<any>) => void;
}

const ProductDescription: React.FC<ProductDescriptionProps> = props => {
  const { data, disabled, errors, onChange } = props;
  const [expanded, setExpanded] = React.useState(true);
  const intl = useIntl();

  const formErrors = getFormErrors(
    [
      // "fromColor",
      // "toColor",
      "shortDescription",
      "fullDescription",
      "skuName",
      "describe",
      "framesImg",
      "framesVideo",
      "USP"
    ],
    errors
  );

  return (
    <Card>
      <CardTitle
        title={intl.formatMessage({
          defaultMessage: "Basic Info",
          description: "product Variants Basic Info"
        })}
        toolbar={
          <Button
            color="primary"
            variant="text"
            disabled={disabled}
            onClick={() => setExpanded(!expanded)}
          >
            <FormattedMessage defaultMessage="Edit" description="button" />
          </Button>
        }
      />
      <CardContent>
        {expanded && (
          <>
            <TextField
              disabled={disabled}
              label={intl.formatMessage({
                defaultMessage: "skuName"
              })}
              error={!!formErrors.skuName}
              helperText={getProductErrorMessage(formErrors.skuName, intl)}
              name="skuName"
              value={data.skuName}
              onChange={onChange}
              fullWidth
            />
            <FormSpacer />
            {/* <TextField
              style={{width:"80%" }}
              disabled={disabled}
              label={intl.formatMessage({
                defaultMessage: "fromColor"
              })}
              error={!!formErrors.fromColor}
              helperText={getProductErrorMessage(formErrors.fromColor, intl)}
              name="fromColor"
              value={data.fromColor}
              onChange={onChange}
            />
              
            <div style={{
                display:"inline-block",
                marginLeft:10,
                marginTop:5,
                width:"18%",
                height:45,
                backgroundColor:data.fromColor}}/>
            <FormSpacer />
            <TextField
              disabled={disabled}
              label={intl.formatMessage({
                defaultMessage: "toColor"
              })}
              error={!!formErrors.toColor}
              helperText={getProductErrorMessage(formErrors.toColor, intl)}
              name="toColor"
              value={data.toColor}
              onChange={onChange}
              style={{width:"80%" }}
            />
            <div style={{
                display:"inline-block",
                marginLeft:10,
                marginTop:5,
                width:"18%",
                height:45,
                backgroundColor:data.toColor}}/>
            <FormSpacer /> */}
            <TextField
              disabled={disabled}
              label={intl.formatMessage({
                defaultMessage: "framesImg"
              })}
              error={!!formErrors.framesImg}
              helperText={getProductErrorMessage(formErrors.framesImg, intl)}
              name="framesImg"
              value={data.framesImg}
              onChange={onChange}
              fullWidth
            />
            <FormSpacer />
            <TextField
              disabled={disabled}
              label={intl.formatMessage({
                defaultMessage: "framesVideo"
              })}
              error={!!formErrors.framesVideo}
              helperText={getProductErrorMessage(formErrors.framesVideo, intl)}
              name="framesVideo"
              value={data.framesVideo}
              onChange={onChange}
              fullWidth
            />
            <FormSpacer />
            <TextField
              disabled={disabled}
              label={intl.formatMessage({
                defaultMessage: "USP"
              })}
              error={!!formErrors.USP}
              helperText={getProductErrorMessage(formErrors.USP, intl)}
              name="USP"
              value={data.USP}
              onChange={onChange}
              fullWidth
              multiline
            />
            <FormSpacer />
            <FormSpacer />
            <TextField
              disabled={disabled}
              label={intl.formatMessage({
                defaultMessage: "describe"
              })}
              error={!!formErrors.describe}
              helperText={getProductErrorMessage(formErrors.describe, intl)}
              name="describe"
              value={data.describe}
              onChange={onChange}
              fullWidth
              multiline
            />
            <FormSpacer />
            <TextField
              disabled={disabled}
              label={intl.formatMessage({
                defaultMessage: "shortDescription"
              })}
              error={!!formErrors.shortDescription}
              helperText={getProductErrorMessage(
                formErrors.shortDescription,
                intl
              )}
              name="shortDescription"
              value={data.shortDescription}
              onChange={onChange}
              fullWidth
              multiline
            />
            <FormSpacer />
            <TextField
              disabled={disabled}
              label={intl.formatMessage({
                defaultMessage: "fullDescription"
              })}
              error={!!formErrors.fullDescription}
              helperText={getProductErrorMessage(
                formErrors.fullDescription,
                intl
              )}
              name="fullDescription"
              value={data.fullDescription}
              onChange={onChange}
              fullWidth
              multiline
            />
          </>
        )}
      </CardContent>
    </Card>
  );
};
ProductDescription.displayName = "ProductDescription";
export default ProductDescription;
